import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { Documento } from "../../../../rh/domain/models/documento";
import { IGetDocumentosUseCase } from "../../../presentation/useCases/read/get_documentos_use_case";

import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

export class GetDocumentosUseCase extends BasePaginatedUseCase<Documento> implements IGetDocumentosUseCase {
  constructor(
    private readonly repository: ITerceirizacaoRepository,
  ) {
    super();
  }

  async getDocumentos(
    idFuncionario: number,
    page: number,
    pageSize: number,
    status?: number,
    situacao?: number,
    DataDe?: string | Date | null,
    DataAte?: string | Date | null,
    NomeDocumento?: string | null
  ): Promise<void> {
    const response = await this.repository.getDocumentos(
      idFuncionario,
      page,
      pageSize,
      status,
      situacao,
      DataDe,
      DataAte,
      NomeDocumento
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}